import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  checkIfDemoUserExist,
  demoLogin,
  forgotPassword,
  loginUser,
  resetPassword,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { APP_CONST } from "../../../config/const";
import PhoneInput from "react-phone-input-2";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import LoaderCircle from "../../../assets/images/LoaderCircle.gif";
import PasswordIcon from "../../../assets/images/icons/padlock.png";
import UserIcon from "../../../assets/images/icons/people.png";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

import LogoWhite from "../../../assets/images/logo-white.png";

const LoginModal = ({ show, handleClose, handleModalShow }) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [mobileNumber, setMobileNumber] = useState("");
  const [changeModalContent, setChangeModalContent] = useState(true);
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isDemoUserExist, setIsDemoUserExist] = useState(false);
  const { appDetails } = useSelector((state) => state.app);
  const [loaders, setLoaders] = useState({
    login: false,
    demoLogin: false,
  });

  useEffect(() => {
    checkDemoUser();
  }, []);

  const checkDemoUser = async () => {
    const response = await checkIfDemoUserExist();
    if (response && response?.data?.error === false) {
      setIsDemoUserExist(response?.data?.data?.hasDemoUsers === true);
    }
  };

  /**
   *
   * @param {string} keyName
   * @param {boolean} booleanValue
   */
  const updateLoaders = (keyName, booleanValue) => {
    setLoaders((p) => ({ ...p, [keyName]: booleanValue }));
  };

  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = "Username cannot be empty";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorData = validateData();

    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      updateLoaders("login", true);
      let loginData = { ...formData };
      // handleClose();
      dispatch(
        loginUser(loginData, () => {
          updateLoaders("login", false);
        })
      );
      handleClose(APP_CONST.AUTH_MODAL.LOGIN);
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  const handleSubmitForgotPass = async (e) => {
    e.preventDefault();
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    if (phoneNumber) {
      payload.phone = phoneNumber.nationalNumber;
      payload.countryCode = phoneNumber.countryCallingCode;
      forgotPassword(payload)
        .then((res) => {
          if (res.data.error === false) {
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP sent");
            setIsOtpSent(true);
          }
        })
        .catch((err) => {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
        });
    } else {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Please enter mobile number");
    }
  };

  const handleSubmitResetPass = () => {
    setIsVerifying(true);

    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "All fields are mandatory");
    } else {
      const payload = {
        otp,
        password,
      };

      resetPassword(payload)
        .then((res) => {
          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Password reset success");
          setChangeModalContent((prev) => !prev);
        })
        .catch((err) => {
          Toaster(
            APP_CONST.TOAST_TYPE.ERROR,
            err.response.data.message || "Request failed"
          );
          setIsVerifying(false);
        });
    }
  };

  const handleDemoLogin = () => {
    dispatch(demoLogin());
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas login-modal login LoginModal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="white"
      >
        <a href="/">
          {appDetails?.LOGO_URL && (
            // <img src={appDetails?.LOGO_URL} alt="Logo" />
            <img src={LogoWhite} alt="Logo" />
          )}
        </a>
      </Modal.Header>
      <Modal.Body>
        {changeModalContent ? (
          <div
            className={
              !changeModalContent ? `login-section` : `login-section active`
            }
          >
            <div className="Login-rightPart LoginNewDesign">
              <Modal.Title>Login</Modal.Title>
              <p>
                Not a member yet?{" "}
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                  }}
                >
                  Sign up
                </a>
              </p>
              <div className="form-steps">
                <Form>
                  <Form.Group className=" mb-4 position-relative">
                    <label>Enter Username</label>
                    <img src={UserIcon} alt="UserIcon" />
                    <Form.Control
                      type="text"
                      name="username"
                      // placeholder="Enter Username"
                      onChange={handleChange}
                      isInvalid={!!errors.username}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors?.username}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className=" mb-4 position-relative">
                    <label>Password</label>
                    <img src={PasswordIcon} alt="PasswordIcon" />
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      // placeholder="Password*"
                      name="password"
                      onChange={handleChange}
                      isInvalid={!!errors.password}
                    />
                    <span
                      className="icon"
                      onClick={() => setShowPassword((s) => !s)}
                    >
                      {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                    </span>
                    <Form.Control.Feedback
                      type="invalid"
                      style={{ display: "block" }}
                    >
                      {errors?.password}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <a
                      className="form-link"
                      onClick={() => {
                        setChangeModalContent((prev) => !prev);
                      }}
                    >
                      Forgot password?
                    </a>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleSubmit}
                      disabled={loaders?.login}
                    >
                      {loaders?.login ? "Loading..." : "Login"}
                    </Button>
                  </div>

                  {(isDemoUserExist && (
                    <Button
                      variant="primary"
                      onClick={handleDemoLogin}
                      className="sign-in-btn mt-2"
                    >
                      Login with Demo Id
                    </Button>
                  )) ||
                    null}
                </Form>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={
              changeModalContent
                ? `login-section`
                : `login-section ForgotPasswordSection`
            }
            // {`login-section  ForgotPasswordSection `}
          >
            <div className="Login-rightPart ForgotPassword">
              <Modal.Title className="mb-4">Reset Password</Modal.Title>
              <div className="form-steps">
                <Form onSubmit={handleSubmitForgotPass} className="">
                  <Form.Group
                    className="position-relative mb-4"
                    controlId="formBasicPassword"
                  >
                    {/* <label>Phone Num</label> */}
                    <PhoneInput
                      country={"in"}
                      countryCodeEditable={false}
                      inputProps={{
                        name: "phone",
                        required: true,
                      }}
                      // onlyCountries={["in"]}
                      inputStyle={{
                        width: "100%",
                      }}
                      onChange={(phone) => {
                        // alert("phone", phone);
                        // alert(phone);
                        setMobileNumber(phone);
                      }}
                    />
                  </Form.Group>
                  {/* <p className="otpnote">You will receive otp from AX-VERBO.</p> */}
                  <Button
                    variant="primary mb-4"
                    type="submit"
                    // onClick={handleSubmitForgotPass}
                  >
                    Get OTP
                  </Button>

                  <Form.Group className="mb-4 position-relative" controlId="">
                    <Form.Control
                      type="text"
                      placeholder="Enter OTP*"
                      onChange={(e) => setOtpValue(e.target.value)}
                      autoComplete="off"
                    />
                  </Form.Group>
                  <Form.Group className="mb-4 position-relative">
                    <Form.Control
                      type="password"
                      placeholder="Enter new password"
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="new-password"
                    />
                    <span
                      className="icon"
                      onClick={() => setShowPassword((s) => !s)}
                    >
                      {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                    </span>
                  </Form.Group>

                  <Button
                    variant="primary mb-4"
                    onClick={handleSubmitResetPass}
                    disabled={!isOtpSent}
                  >
                    {!isVerifying ? "SUBMIT" : "SUBMITTING"}
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default LoginModal;
